import React from 'react';
import { MenuItem, Select } from '@material-ui/core';
import fontSizes from './fontSizes';
import * as R from 'ramda';

function FontSize({ editorState, onToggle }) {

    const currentStyle = editorState.getCurrentInlineStyle();
   
    const fontStyle = currentStyle.reduce((fontStyle, style) => {
        if (R.contains('fontsize', style)) {
            return fontStyle = {
                fontSize: style
            }
        }
        return fontStyle
    }, {})

    const size = !R.isEmpty(fontStyle) && fontStyle.fontSize.split('-')[1]
    
    const handleChange = ({ target }) => onToggle('fontSize', target.value);

    return (
        <Select
            value={size || 16}
            onChange={handleChange}
        >
            {fontSizes.map((size, i) => (
                <MenuItem
                    dense
                    key={i}
                    value={size.value}
                >
                    {size.value}
                </MenuItem>

            ))}
        </Select>
    );
}

export default FontSize
